import React from 'react';
import AppScreen from './Assets/screen.png';
import config from './Config'

import appstore from './Assets/appstore.png'
import googleplay from './Assets/googleplay.png'

import './Hero.css';

const Hero = () => {
    return (
        <section id="hero" className="hero">
            <div className="hero_content">
                <div className="hero_text">
                    <h1 className="hero_headline">
                        HomeApp – Smarter Living Simplified.
                    </h1>
                    <p className="hero_subheadline">
                        Book trusted professionals for plumbing, electrical, cleaning, and more — anytime, anywhere.
                    </p>
                    <div className="">
                        <a href="#" className="">
                            <img src={appstore} alt="Download on App Store" className="download_icon" />
                        </a>

                        <a href={config.playstorelink} className="">
                            <img src={googleplay} alt="Get it on Google Play" className="download_icon" />
                        </a>
                    </div>
                </div>

                <div className="hero_image">
                    <img src={AppScreen} alt="App Screen" className="hero_image_screen" />
                </div>
            </div>
        </section>
    );
};

export default Hero;
